<template>
    <div v-if="renderType === 'simplefile'" :class="classNamesElement">
        <span v-if="droppedFile && deleteTarget" @click="deleteFiles"
              class="dropzone--delete btn btn--icon-inline">
            <svg-vue icon="documents-file-delete-cross" class="icon"/>
        </span>
        <label v-if="label" :for="field">
            <translate>{{ label }}</translate>
        </label>
        <div v-bind="getRootProps()">
            <span class="form-input file-input-faker">
                {{ inputText }}
            </span>
            <svg-vue v-if="!droppedFile" icon="documents-file-search" class="icon"/>
            <input :id="field" v-bind="getInputProps()"/>
        </div>
        <div class="dropzone--progress" v-if="fileUploading">
            <div class="outer">
                <div class="inner" :style="{ width : fileUploadProgress +'%' }"></div>
            </div>
        </div>
        <span v-if="errorOrInfo" class="form-info"><translate>{{ errorOrInfo }}</translate></span>
    </div>
    <div v-else :class="classNamesElement">
        <span v-if="droppedFile && deleteTarget" @click="deleteFiles"
              class="dropzone--delete btn btn--icon-inline btn--dense">
            <svg-vue icon="documents-file-delete-cross" class="icon"/>
        </span>

        <div v-bind="getRootProps()">
            <label v-if="this.$slots.label" :for="field">
                <slot name="label"/>
            </label>
            <div class="dropzone--area"
                 :class="{'dropzone--active' : isDragActive, 'dropzone--uploading' : fileUploading, 'dropzone--uploaded' : filePreviewPath}">

                <div class="dropzone--icon">
                    <svg-vue icon="cloud-upload" class="icon"/>
                </div>
                <div class="dropzone--info">
                    <p v-if="isDragActive && !filePreviewPath">
                        <slot name="textDrag"/>
                    </p>
                    <p v-else-if="isDragActive && filePreviewPath">
                        <slot name="textReplace"/>
                    </p>
                    <p v-else>
                        <slot name="textdefault"/>
                    </p>
                </div>
                <div class="dropzone--progress" v-if="fileUploading">
                    <div class="outer">
                        <div class="inner" :style="{ width : fileUploadProgress +'%' }"></div>
                    </div>
                </div>
                <div class="dropzone--preview" v-if="filePreviewPath">
                    <img :src="filePreviewPath">
                </div>
                <input :id="field" v-bind="getInputProps()"/>
            </div>
        </div>
        <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
    </div>
</template>
<script>
import {useDropzone} from 'vue3-dropzone';
import axios from 'axios';

export default {
    name: 'FormDropZone',
    props: {
        renderType: {
            String,
            default: 'dropzone',
        },
        field: null,
        data: null,
        fileSize: null,
        fileType: null,
        currentFile: null,
        maxFiles: null,
        maxFilesize: null,
        error: null,
        info: null,
        uploadTarget: null,
        deleteTarget: null,
        label: null,
        disabled: null,
        askForQuoteDocument: null,
        askForQuoteIndex: null,
    },
    data() {
        let filePreview = null;
        let fileUploadProgress = null;
        let classNames = ['dropzone', 'form-element'];
        let rejectErrorString = null;
        let askForQuoteIndexProxy = this.askForQuoteIndex;
        let droppedFile = this.currentFile;
        let droppedInfo = this.info;

        const onDrop = (acceptFiles, rejectReasons) => {
            if (acceptFiles.length > 0) {
                this.$emit('acceptFiles', acceptFiles);
                // Todo Upload Multiple Files
                this.uploadFiles(acceptFiles[0]);
            }
            if (rejectReasons.length > 0) {
                this.$emit('rejectReasons', rejectReasons);
                this.rejectError(rejectReasons);
                console.log(rejectReasons);
            }
        };

        const {getRootProps, getInputProps, ...rest} = useDropzone({
            onDrop,
            accept: this.fileType,
            multiple: this.maxFiles > 1,
            maxFiles: this.maxFiles,
            maxSize: this.maxFilesize * 1024 * 1024,
            disabled: this.disabled
        });

        return {
            askForQuoteIndexProxy,
            droppedFile,
            droppedInfo,
            filePreview,
            fileUploadProgress,
            classNames,
            rejectErrorString,
            getRootProps,
            getInputProps,
            ...rest,
        };
    },
    computed: {
        classNamesElement() {
            let classNamesElement = this.classNames;
            if (this.error) classNamesElement.push('form-element--error');
            if (this.disabled) classNamesElement.push('form-element--disabled');
            if (this.renderType === 'simplefile') classNamesElement.push('form-element--file', 'form-input--icon');

            return classNamesElement;
        },
        errorOrInfo() {
            const infoString = this.renderType !== 'simplefile' && this?.droppedFile?.file_informations?.original_name ? this?.droppedFile?.file_informations?.original_name : this.info;
            return infoString ? infoString : this.rejectErrorString ? this.rejectErrorString : this.error;
        },
        fileUploading() {
            return this.fileUploadProgress > 0 && this.fileUploadProgress < 100;
        },
        filePreviewPath() {
            const param = this?.droppedFile?.id ? this.droppedFile.id : this.droppedFile?.client_file ? 'client' : 'producer';
            if (this.askForQuoteDocument) {
                return this?.droppedFile?.file_informations?.thumbnail ? '/ask-for-quote-documents/serve/' + param + '?' + Date.now() : '';
            } else if (this.askForQuoteIndexProxy !== null && this.askForQuoteIndexProxy !== undefined){
                return this?.droppedFile?.file_informations?.thumbnail ? '/sketch-file/serve/' + param + '/'+this.askForQuoteIndexProxy+'?' + Date.now() : '';
            } else {
                return this?.droppedFile?.file_informations?.thumbnail ? '/sketch-file/serve/' + param + '?' + Date.now() : '';
            }

        },
        inputText() {
            return this?.droppedFile?.file_informations?.original_name ? this?.droppedFile?.file_informations?.original_name : this.$gettext('keine Datei ausgewählt');
        },
    },
    methods: {
        uploadFiles(acceptFiles) {
            const url = this.data?.askForQuote ? this.$$route(this.uploadTarget, {'askForQuote': this.data?.askForQuote}) : this.data?.producerOrder ?
                this.$$route(this.uploadTarget, {'producerOrder': this.data?.producerOrder}) : this.$$route(this.uploadTarget, {'askForQuoteIndex': this.askForQuoteIndexProxy});

            let formData = new FormData();
            formData.append(this.field, acceptFiles);

            if (this.data) {
                Object.entries(this.data).forEach(entry => {
                    const [key, value] = entry;
                    formData.append(key, value);
                });
            }

            axios
                .post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': this.$page.props.csrf_token,
                    },
                    onUploadProgress: e => {
                        this.fileUploadProgress = (e.loaded / e.total) * 100;
                    }
                })
                .then((response) => {
                    this.classNames = this.classNames.filter(e => e !== 'form-element--error');
                    this.rejectErrorString = '';
                    this.droppedFile = response.data;
                    this.$emit('uploadedFiles', this.droppedFile);

                })
                .catch((error) => {
                    if (error.response) {
                        this.classNames.push('form-element--error');
                        this.rejectErrorString = error.response.data.errors[this.field][0];
                    }
                });
        },
        deleteFiles() {
            // const url = this.$$route(this.deleteTarget);
            const url = this.data?.askForQuote ? this.$$route(this.deleteTarget, {'askForQuote': this.data?.askForQuote}) : this.data?.producerOrder ? this.$$route(this.deleteTarget, {'producerOrder': this.data?.producerOrder}) : this.$$route(this.deleteTarget, {'askForQuoteIndex': this.askForQuoteIndexProxy});
            let formData = new FormData(); // pass data as a form
            formData.append('type', this.field);
            axios
                .post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': this.$page.props.csrf_token,
                    },
                })
                .then(() => {
                    this.droppedFile = null;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        rejectError(rejectReasons) {
            this.classNames.push('form-element--error');
            rejectReasons.forEach((file) => {
                this.rejectErrorString = file.errors[0]['code'];
            });
        }
    },
    watch: {
        currentFile: function(value){
            this.droppedFile = value;
        },
    },
    emits: ['acceptFiles', 'rejectReasons', 'uploadedFiles']
};
</script>
